export default "__VITE_ASSET__CVSwLBFR__"